import { useEffect, useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { getAdminDashboard } from "../client/admin";

function StatCard({ title, value }) {
  return (
    <Paper elevation={2} sx={{ p: 3, textAlign: "center" }}>
      <Typography variant="h4" color="primary" gutterBottom>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
    </Paper>
  );
}

function DashboardPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const res = await getAdminDashboard();
    if (res) setData(res);
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        仪表盘
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard title="注册用户" value={data?.user_count ?? "-"} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard title="排盘记录" value={data?.people_count ?? "-"} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard title="今日排盘" value={data?.today_people ?? "-"} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard title="激活码总数" value={data?.code_total ?? "-"} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard title="已使用激活码" value={data?.code_used ?? "-"} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <StatCard
            title="剩余激活码"
            value={data ? data.code_total - data.code_used : "-"}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default DashboardPage;
